export const iframeSrcAppendQuery = (iframeSrc, siteQueryString) => {
  const iframeUrl = iframeSrc.split('?')[0];
  const iframeQueryString = iframeSrc.split('?')[1];

  const iframeQuery = new URLSearchParams(iframeQueryString);
  const siteQuery = new URLSearchParams(siteQueryString);

  siteQuery.forEach((value, key) => {
    iframeQuery.append(key, value);
  });

  return iframeUrl + '?' + iframeQuery.toString();
};
